import './styles.scss';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';
import { collection, query, orderBy } from 'firebase/firestore';
import CMSTable from '../CMSTable';
export default function CMSParks(props) {

  const firestore = useFirestore();
  const parksCollection = collection(firestore, 'parks');

  const parksQuery = query(parksCollection, orderBy('name', 'asc'));
  const { data: parks } = useFirestoreCollectionData(parksQuery);
  console.log(parks)
  const parksTable = parks ?
    <CMSTable
      data={parks}
      columns={[
        {
          name: 'Name',
          accessor: row => row.name,
        }
      ]}
    />
    : null
  return (
    <div className='CMSParks'>
      <h2>Parks</h2>
      {parksTable}
    </div>
  )
}
